import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { router } from './router';

import './styles/normalize.css';
import './styles/theme.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('main') as HTMLElement).render(
  <React.StrictMode>
    <React.Suspense fallback={null}>
      <RouterProvider router={router} />
    </React.Suspense>
  </React.StrictMode>,
);
